document.addEventListener('click', (e) => {
  if (e.target.closest('a.nav-category__item')) {
    const category = e.target.closest('a.nav-category__item')?.dataset.category
    if (category) {
      window.location.hash = category;
      handleHash();
    }
  }
})

const handleHash = () => {
  const hash = window.location.hash;
  const cleanHash = hash.substring(1);

  scrollToCategory(cleanHash);
};

const scrollToCategory = (category) => {
  const contentItem = document.querySelector(`.category-list__content-item[data-category="${category}"]`);
  const additionalOffset = 30;

  if (contentItem) {
    const offsetTop = contentItem.offsetTop - additionalOffset;
    const fixedCategory = document.querySelector('.category-list__header-fixed');
    const header = document.querySelector('.js-category-title');
    let scrollToPosition = header ? offsetTop - header.clientHeight : offsetTop;

    scrollToPosition = fixedCategory ? scrollToPosition - fixedCategory.clientHeight : scrollToPosition;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });

    highLightCategory(category);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    handleHash();
  }
});

const highLightCategory = (category) => {
  const categoryTitlesFixed = document.querySelectorAll('.category-list__header-fixed-item .category-list__header-fixed-item-title');
  const currentTitleFixed = document.querySelector(`.category-list__header-fixed-item[data-title="${category}"] .category-list__header-fixed-item-title`);
  categoryTitlesFixed?.forEach((element) => element.classList.remove('category-title--active'));
  currentTitleFixed?.classList.add('category-title--active');
}